import React, { Component, useState } from "react";
import { connect } from "react-redux";
import ReactDOM from "react-dom"; // 必要なimport文を追加
import { changeSwModeAction, changeEditerModeAction, changeInPredictAction, finLrnAction, changeInExeWaitngAction, changeWaitngTimeAction } from "../../redux/app/actions";
import { regEditerAction, changeBoringID1Action, changeBoringID2Action } from "../../redux/editer/actions";
import { changeRegionAction, changeCoordAction } from "../../redux/modelArea/actions";
import { openSwAction, openEditerAction, showRegionModelWindowAction, openEstBoringAction, selectWaterShedAction, showTestDataWindowAction, showMeaTimeWindowAction, showOutTimeWindowAction, showInputTempWindowAction } from "../../redux/ui/actions";
import { changeDeltaTAction, updateLakeTrAction } from "../../redux/well/actions";
import {
  addDsAction,
  changeDsAction,
  isDrawAction,
  isOkAction,
  changeAnalyRadiusAction,
  changeAnalyBHHeightAction,
  changeAnalyPumpAction,
  changeAnalyWLAction,
  changeMeshRadiusAction,
  changeMeshVertexAction,
  changeMeshSplitAction,
  changeMeshBiasAction,
  changeAnalyTargetAction,
  changePompAmountAction,
  changeWLDAmountAction,
  changeBoringScoreAction,
  changeModelKindAction,
  changeMeshZSplitAction,
  addPompTrAction,
  addScreenTrAction,
  delPompTrAction,
  updatePompTrAction,
  changePompTrSelRowAction,
  delScreenTrAction,
  changePreWLAction,
  changeSameDepthAction,
  changeBorDsAction,
  changeScreenZSplitAction,
  changeMapMeshLayAction,
  changeEquPermCheckAction,
  changeProbThresholdAction,
  changeNewDsAction,
  changeCrossValidAction,
  changeWsArAction,
  changeRegNumAction,
  changeAutoScrChkAction,
  changeConsiderMatAction,
  changeBudgetAction,
  changeUnitCostAction,
  changeMaxScrNumAction,
  changeAnalysisTypeAction,
  changeOptWSAction,
  changeChkKAction,
  changeCheckPreIndAction,
  changeInitTempAction,
} from "../../redux/boring/actions";
import Select from "../common/Select";
import Sw from "../common/Sw";
import RegionModelWindow from "./Wells";
import TestData from "./TestData";
import OutTime from "./OutTime";
import FreeUser from "./FreeUser";
import PaidUser from "./PaidUser";
import StanUser from "./StanUser";
import DevUser from "./DevUser";
import jschardet from "jschardet";

const mapStateToProps = state => {
  return {
    region: state.modelAreaReducer.region,
    coord: state.modelAreaReducer.coord,
    paramRegion: state.paramReducer.region,
    boringDs: state.boringReducer.dataset,
    editerSw: state.uiReducer.editerSw,
    analyRadius: state.boringReducer.analyRadius,
    analyBHHeight: state.boringReducer.analyBHHeight,
    analyPump: state.boringReducer.analyPump,
    analyWL: state.boringReducer.analyWL,
    meshRadius: state.boringReducer.meshRadius,
    meshVertex: state.boringReducer.meshVertex,
    meshSplit: state.boringReducer.meshSplit,
    meshZSplit: state.boringReducer.meshZSplit,
    meshBias: state.boringReducer.meshBias,
    analyTarget: state.boringReducer.analyTarget,
    pompAmount: state.boringReducer.pompAmount,
    wldAmount: state.boringReducer.wldAmount,
    csLineDs: state.csLineReducer.dataset,
    modelKind: state.boringReducer.modelKind,
    pompTrData: state.boringReducer.pompTrData,
    pompTrSelRow: state.boringReducer.pompTrSelRow,
    screenTrData: state.boringReducer.screenTrData,
    screenZSplit: state.boringReducer.screenZSplit,
    mapMeshLay: state.boringReducer.mapMeshLay,
    equPermCheck: state.boringReducer.equPermCheck,
    probThreshold: state.boringReducer.probThreshold,
    crossValid: state.boringReducer.crossValid,
    regMode: state.appReducer.regMode,
    geoDs: state.geoReducer.dataset,
    regNum: state.boringReducer.regNum,
    selRow: state.boringReducer.selRow,
    ds: state.boringReducer.dataset,
    catData: state.boringReducer.catData,
    name: state.boringReducer.name,
    cat: state.boringReducer.cat,
    geoInfo: state.boringReducer.geoInfo,
    coordSystem: state.boringReducer.coordSystem,
    color: state.boringReducer.color,
    tab: state.boringReducer.tab,
    isOk: state.boringReducer.isOk,
    isDraw: state.boringReducer.isDraw,
    file: state.boringReducer.file,
    XAttr: state.boringReducer.XAttr,
    YAttr: state.boringReducer.YAttr,
    depThkRdo: state.boringReducer.depThkRdo,
    ZAttr: state.boringReducer.ZAttr,
    geo: state.boringReducer.geo,
    ID: state.boringReducer.ID,
    GLChk: state.boringReducer.GLChk,
    GL: state.boringReducer.GL,
    WLChk: state.boringReducer.WLChk,
    WL: state.boringReducer.WL,
    headerNum: state.boringReducer.headerNum,
    fieldNameChk: state.boringReducer.fieldNameChk,
    csvData: state.boringReducer.csvData,
    newData: state.boringReducer.newData,
    formData: state.boringReducer.formData,
    userData: state.boringReducer.userData,
    boringID1: state.editerReducer.boringID1,
    boringID2: state.editerReducer.boringID2,
    newDs: state.boringReducer.newDs,
    regionModelWindowVisible: state.uiReducer.regionModelWindowVisible,
    id: state.userReducer.id,
    wellsTrData: state.boringReducer.wellsTrData,
    waterShedSelectable: state.uiReducer.waterShedSelectable,
    moduleTable: state.appReducer.moduleTable,
    wsAr: state.boringReducer.wsAr,
    impWS: state.appReducer.impWS,
    userLicense: state.appReducer.userLicense,
    regNum: state.boringReducer.regNum,
    preWL: state.boringReducer.preWL,
    sameDepth: state.boringReducer.sameDepth,
    boringScore: state.boringReducer.boringScore,
    autoScrChk: state.boringReducer.autoScrChk,
    considerMat: state.boringReducer.considerMat,
    budget: state.boringReducer.budget,
    unitCost: state.boringReducer.unitCost,
    maxScrNum: state.boringReducer.maxScrNum,
    testDataWindowVisible: state.uiReducer.testDataWindowVisible,
    wlTrDataTS: state.wellReducer.wlTrData,
    pompTrDataTS: state.wellReducer.pompTrData,
    analyType: state.boringReducer.analyType,
    optWS: state.boringReducer.optWS,
    chkK: state.boringReducer.chkK,
    editerWlMeaData: state.editerReducer.editerWlMeaData,
    editerPompMeaData: state.editerReducer.editerPompMeaData,
    outTimeWindowVisible: state.uiReducer.outTimeWindowVisible,
    deltaT: state.wellReducer.deltaT,
    outTimeTrData: state.wellReducer.outTimeTrData,
    gmUrl: state.appReducer.gmUrl,
    initTemp: state.boringReducer.initTemp,
    lakeTrData: state.wellReducer.lakeTrData,
  };
};
class Main extends Component {
  constructor(props) {
    super(props);
    //地域オプション
    this.regionOpt = [{ val: "0", text: "全表示" }];
    for (let key in this.props.paramRegion) {
      this.regionOpt.push({
        val: key,
        text: key + " : " + this.props.paramRegion[key].name,
      });
    }

    this.closeSw = this.closeSw.bind(this);
    this.changeIdoPram = this.changeIdoPram.bind(this);
    this.checkTarget = this.checkTarget.bind(this);
    this.doExe = this.doExe.bind(this);
    this.linkGM = this.linkGM.bind(this);
    this.changeVisible = this.changeVisible.bind(this);
    this.checkInput = this.checkInput.bind(this);
    this.checkCenterPoint = this.checkCenterPoint.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.changeRow = this.changeRow.bind(this);
    this.checkModelKind = this.checkModelKind.bind(this);
    this.checkIdoPram = this.checkIdoPram.bind(this);
    this.deleteSel = this.deleteSel.bind(this);
    this.changeField = this.changeField.bind(this);
    this.getTargetBor = this.getTargetBor(this);
    this.deleteSelectedWaterShed = this.deleteSelectedWaterShed.bind(this);
    //this.props.dispatch(changeEditerModeAction(1));
    this.csIDCoordlst = [];
    this.modelAreaCoord = [];
    this.scrList = [];
    this.conList = [];
    this.boringID1 = this.props.boringID1;
    this.boringID2 = this.props.boringID2;

    this.isStart = false; //描画を開始している場合true
    window.setDrawingFlag(true);
    this.showRegion();
    console.log(this.props.editerPompMeaData);
    console.log(this.props.chkK);
    if (this.props.modelKind == 3) {
      const selectedWScoords = window.getSelectedWaterShed().selectedFeaturesCoord;
      if (selectedWScoords.length != 0) {
        const newModelArea = window.retWSDataset(selectedWScoords);
        window.changeModelArea(newModelArea[2], newModelArea[3], newModelArea[0], newModelArea[1], true);
      }
      if (this.props.waterShedSelectable) {
        window.endModelArea(false);
        window.changeShowData("ws", true);
        window.startSelectWaterShed();
        this.props.dispatch(selectWaterShedAction(true));
      }
      if (this.props.regionModelWindowVisible) {
        window.endModelArea(false);
        window.startMultiWells();
        this.props.dispatch(showRegionModelWindowAction(true));
      }
    }
  }

  /*
   * 地域を地図上に表示
   * @since hara 2021-03-23
   */
  showRegion() {
    /*
        const coords = [];
        for (let key in this.props.paramRegion) {
            coords.push(this.props.paramRegion[key].range);
        }
        if (window.existModelArea() || this.props.wellsTrData.length != 0) {
            window.showRegion(coords, 10, false);
        } else {
            window.showRegion(coords, 10, true);
        }
        */

    if (!this.isStart) {
      if (this.props.modelKind != 3) {
        //window.startModelArea(true);
      }
      this.isStart = true;
    }
  }

  changeRow = e => {
    e.target.closest("tbody").childNodes.forEach(el => {
      el.classList.remove("selRow");
    });
    const tr = e.target.closest("tr");
    tr.classList.add("selRow");
    this.props.dispatch(changePompTrSelRowAction(tr.id));
    console.log(`Row ${tr.id} clicked!`);
  };

  waiting = stat => {
    this.props.dispatch(changeInPredictAction(stat));
  };

  /*
   * 推定実行
   * @since kawai 2020-09-09
   */
  async doLearn(pred) {
    const origin = window.location.origin;
    const search = window.location.search;
    /*
     * 入力値確認
     */
    let useChk = true;
    this.props.boringDs.forEach(el => {
      if (el.use) useChk = false;
    });
    if (useChk) {
      alert("推定に使用するボーリングデータセットを1つ以上選択してください。");
      return;
    }
    if (this.props.modelDep < 1 || 1000 < this.props.modelDep) {
      alert("モデル深度は 1~1000 の範囲で設定してください。");
      return;
    }

    /*
     * 推定
     */

    this.waiting(true);

    //チェックされたボーリングの情報を取得
    //boringDsのuseプロパティを使用するよう修正 @since hara 2020-10-08
    let selectedBoring = [];
    this.props.boringDs.forEach(el => {
      if (el.use) {
        selectedBoring.push({
          ID: el["ID"],
          name: el["name"],
        });
      }
    });

    //流域界モデルかつ連動のときは、流域界を内包する範囲を学習領域とする。
    let dr;
    if (this.props.modelKind == 3) {
      this.modelAreaCoord = window.getmodelAreaCoord();
      console.log("inCityDetector", this.modelAreaCoord);
      const result = window.getSelectedWaterShed();
      let selectedFeaturesCoord;
      if (this.props.optWS && this.props.wellsTrData.length != 0) {
        const selected = window.getALLWaterShed([(this.modelAreaCoord[2] + this.modelAreaCoord[3]) / 2, (this.modelAreaCoord[0] + this.modelAreaCoord[1]) / 2], result);
        selectedFeaturesCoord = selected.selectedFeaturesCoord;
      } else if (this.props.wellsTrData.length == 0 || this.props.wellsTrData == undefined) {
        const selected = window.getALLWaterShed([(this.modelAreaCoord[2] + this.modelAreaCoord[3]) / 2, (this.modelAreaCoord[0] + this.modelAreaCoord[1]) / 2], result);
        selectedFeaturesCoord = selected.selectedFeaturesCoord;
      } else {
        selectedFeaturesCoord = result.selectedFeaturesCoord;
      }
      dr = this.retWSDataset(selectedFeaturesCoord);
    } else if (this.props.analyType == 5 || this.props.analyType == 6) {
      if (this.props.chkK != null) {
        let DEF_MODEL_AREA = window.getDefModelArea();
        dr = [this.props.chkK[2].lon - DEF_MODEL_AREA[0], this.props.chkK[2].lon + DEF_MODEL_AREA[0], this.props.chkK[2].lat - DEF_MODEL_AREA[1], this.props.chkK[2].lat + DEF_MODEL_AREA[1]];
      } else {
        alert("使用する井戸が選択されていません。");
      }
    } else {
      let tmp = window.getmodelAreaCoord();
      dr = [tmp[2], tmp[3], tmp[1], tmp[0]];
    }
    //console.log('===================近傍点井戸ID===================')
    //console.log(window.getModelMarkerNearPoint())
    //サーバへ指定したボーリングを使用して学習を行うように要求
    await fetch(`${origin}/api/user/0/model/${search}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        selectedBoring: selectedBoring,
        //モデル領域機能で選択した領域でモデルを作成する
        range: {
          x1: dr[0],
          x2: dr[1],
          y1: dr[2],
          y2: dr[3],
          rp: this.props.crossValid == 0 ? "none" : window.getModelMarkerNearPoint(),
          mk: this.props.modelKind == undefined ? null : this.props.modelKind,
          wells: this.props.modelKind == 3 ? this.props.wellsTrData : null,
          exe: "linkGM",
          point: window.getCP(),
        },
      }),
    })
      .then(res => res.json())
      .then(res => {
        console.log("res", res);
        if (res.result == "limit") {
          alert("現在サーバーが混み合っております。時間を空けて再度お試しください。");
          this.waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else if (res.result == "outside") {
          alert("対応範囲外です。お手数ですが、位置を変更し再実行してください。");
          this.waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else if (JSON.parse(res).result == "timeout") {
          alert("タイムアウトエラーが発生しました。選択しているボーリング数を減らし、再度お試しください。");
          this.waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else if (res.result == "fetcherror") {
          alert("サーバー内部エラーが発生しました。システム管理者に確認してくだい。");
          this.waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else {
          if (!pred) {
            this.linkGM();
          } else {
          }
          //予測位置サブウィンドウを開けるようにする
          this.props.dispatch(finLrnAction(true));
        }
      })
      .catch(err => {
        console.log(err);
        alert("サーバーエラー");
        this.waiting(false);
        this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
      });
  }

  /*
   * ポンプ変更
   * @param {Event} e イベント情報
   * @since ando 2023-08-07
   */
  changeIdoPram(e, id) {
    console.log(id);
    switch (id) {
      case "mr": //モデル半径
        return this.props.dispatch(changeMeshRadiusAction(e.target.value));
      case "mv": //周方向分割数
        return this.props.dispatch(changeMeshVertexAction(e.target.value));
      case "ms": //半径方向分割数
        return this.props.dispatch(changeMeshSplitAction(e.target.value));
      case "msz": //鉛直方向分割数
        return this.props.dispatch(changeMeshZSplitAction(e.target.value));
      case "mb": //半径方向バイアス
        return this.props.dispatch(changeMeshBiasAction(e.target.value));
      case "ar": //井戸寸法半径
        return this.props.dispatch(changeAnalyRadiusAction(e.target.value));
      case "ah": //井戸寸法下端深度
        return this.props.dispatch(changeAnalyBHHeightAction(e.target.value));
      case "ap": //ポンプ位置深度
        return this.props.dispatch(changeAnalyPumpAction(e.target.value));
      case "aw": //初期水位
        return this.props.dispatch(changeAnalyWLAction(e.target.value));
      case "tp": //揚水量
        return this.props.dispatch(changePompAmountAction(e.target.value));
      case "tw": //水位低下量
        return this.props.dispatch(changeWLDAmountAction(e.target.value));
      case "at":
        console.log(e);
        if (this.props.modelKind == 1) {
          return this.props.dispatch(changeAnalyTargetAction(e));
        }
        return;
      case "mt":
        console.log(e);
        const div1 = document.getElementById("modelKind");
        const div2 = document.getElementById("modelInputLabel");
        switch (e) {
          case 1:
            if (div2 != null) {
              div2.innerText = "モデル半径(m)：";
            }
            window.endModelArea(false);
            div1.style.display = "block";
            window.changeShowData("ws", false);
            window.endSelectWaterShed();
            //window.startModelArea(true);
            window.endMultiWells();
            this.props.dispatch(openEstBoringAction(null));
            this.props.dispatch(showRegionModelWindowAction(false));
            this.props.dispatch(selectWaterShedAction(false));

            //流域界モデルで設定される学習領域を変更する
            const newModelArea = window.getCP();
            const modelRange = window.getDefModelArea();
            window.changeModelArea(newModelArea[1] - modelRange[1], newModelArea[1] + modelRange[1], newModelArea[0] - modelRange[0], newModelArea[0] + modelRange[0], false);

            //this.props.dispatch(changeEditerModeAction(1));
            this.props.dispatch(changeAnalysisTypeAction(2));
            break;
          case 2:
            if (div2 != null) {
              div2.innerText = "平面分割数：";
            }
            window.endModelArea(false);
            div1.style.display = "none";
            window.changeShowData("ws", false);
            window.startModelArea(true);
            window.endMultiWells();
            this.props.dispatch(openEstBoringAction(null));
            this.props.dispatch(showRegionModelWindowAction(false));
            this.props.dispatch(selectWaterShedAction(false));
            //this.props.dispatch(changeEditerModeAction(1));
            this.props.dispatch(changeAnalysisTypeAction(2));
            break;
          case 3:
            //if (this.props.impWS || this.props.userLicense == 0) {//流域界データをアップロードしているか、管理者ユーザーの場合
            if (div2 != null) {
              div2.innerText = "平面分割数：";
            }
            //div1.style.display = "none";
            this.props.dispatch(changeEditerModeAction(0));
            if (this.props.waterShedSelectable) {
              window.changeShowData("ws", true);
              window.startSelectWaterShed();
              this.props.dispatch(selectWaterShedAction(true));
              this.props.dispatch(changeEditerModeAction(1));
            }
            if (this.props.regionModelWindowVisible) {
              window.startMultiWells();
              this.props.dispatch(showRegionModelWindowAction(true));
              this.props.dispatch(changeEditerModeAction(1));
            }
            this.props.dispatch(changeAnalyTargetAction(0)); //目標量を水位低下にする
            window.endModelArea(false);
            //学習領域を流域界の範囲にする
            const selectedWScoords = window.getSelectedWaterShed().selectedFeaturesCoord;
            if (selectedWScoords.length != 0) {
              const newModelArea = window.retWSDataset(selectedWScoords);
              window.changeModelArea(newModelArea[2], newModelArea[3], newModelArea[0], newModelArea[1], true);
            }
            //} else {
            //    alert('環境データタブから流域界データをアップロードしてください。')
            //    return;
            //}
            this.props.dispatch(changeAnalysisTypeAction(2));
            break;
        }
        return this.props.dispatch(changeModelKindAction(e));
      case "mml": //マップドメッシュ化層番号：
        return this.props.dispatch(changeMapMeshLayAction(e.target.value));
      case "szs": //スクリーン補正鉛直分割数：
        return this.props.dispatch(changeScreenZSplitAction(e.target.value));
      case "ep": //等価透水係数補正
        return this.props.dispatch(changeEquPermCheckAction(e.target.value));
      case "pt": //推定確率閾値(%)
        return this.props.dispatch(changeProbThresholdAction(e.target.value));
      case "cv":
        if (this.props.crossValid == 0) {
          return this.props.dispatch(changeCrossValidAction(1));
        } else {
          return this.props.dispatch(changeCrossValidAction(0));
        }
      case "sd":
        if (this.props.sameDepth == 0) {
          return this.props.dispatch(changeSameDepthAction(1));
        } else {
          return this.props.dispatch(changeSameDepthAction(0));
        }
      case "optws":
        if (this.props.optWS) {
          //流域界選択チェックがオンの時　オン→オフ
          return this.props.dispatch(changeOptWSAction(false));
        } else {
          //流域界選択チェックがオフの時　オフ→オン
          return this.props.dispatch(changeOptWSAction(true));
        }
      case "ws":
        if (this.props.waterShedSelectable) {
          //流域界選択チェックがオンの時　オン→オフ
          window.changeShowData("ws", false);
          window.endSelectWaterShed();
          this.props.dispatch(changeEditerModeAction(0));
          return this.props.dispatch(selectWaterShedAction(false));
        } else {
          if (window.getZoom() < 20) {
            alert("ズームレベルを20以上にしてください。");
            return;
          } else {
            //流域界選択チェックがオフの時　オフ→オン
            window.endModelArea(false);
            window.changeShowData("ws", true);
            window.startSelectWaterShed();

            //複数井戸をオフにする
            window.endMultiWells();
            this.props.dispatch(openEstBoringAction(null));
            this.props.dispatch(showRegionModelWindowAction(false));
            this.props.dispatch(changeEditerModeAction(1));
            return this.props.dispatch(selectWaterShedAction(true));
          }
        }
      case "wells":
        if (this.props.regionModelWindowVisible) {
          //複数井戸チェックがオンの時　オン→オフ
          window.endMultiWells();
          this.props.dispatch(openEstBoringAction(null));
          this.props.dispatch(changeEditerModeAction(0));
          return this.props.dispatch(showRegionModelWindowAction(false));
        } else {
          //複数井戸チェックがオフの時　オフ→オン
          window.endModelArea(false);
          window.startMultiWells();

          //流域界選択をオフにする
          window.changeShowData("ws", false);
          window.endSelectWaterShed();
          this.props.dispatch(selectWaterShedAction(false));

          this.props.dispatch(changeEditerModeAction(1));
          //複数井戸選択用のサブウィンドウを出す。
          return this.props.dispatch(showRegionModelWindowAction(true));
        }
      case "wsAr": //流域界モデル井戸半径
        return this.props.dispatch(changeWsArAction(e.target.value));

      case "asc":
        if (this.props.autoScrChk) {
          return this.props.dispatch(changeAutoScrChkAction(false));
        } else {
          return this.props.dispatch(changeAutoScrChkAction(true));
        }
      case "alt":
        return this.props.dispatch(changeAnalysisTypeAction(e.target.value));
      case "cm":
        return this.props.dispatch(changeConsiderMatAction(e.target.value));
      case "msn":
        return this.props.dispatch(changeMaxScrNumAction(e.target.value));
      case "bud":
        return this.props.dispatch(changeBudgetAction(e.target.value));
      case "uc":
        return this.props.dispatch(changeUnitCostAction(e.target.value));
      case "testData":
        if (this.props.testDataWindowVisible) {
          this.props.dispatch(showMeaTimeWindowAction(false));
          return this.props.dispatch(showTestDataWindowAction(false));
        } else {
          return this.props.dispatch(showTestDataWindowAction(true));
        }
      case "outTime":
        if (this.props.outTimeWindowVisible) {
          this.props.dispatch(showOutTimeWindowAction(false));
          return this.props.dispatch(showOutTimeWindowAction(false));
        } else {
          return this.props.dispatch(showOutTimeWindowAction(true));
        }
      case "deltaT":
        return this.props.dispatch(changeDeltaTAction(e.target.value));
      case "initTemp":
        return this.props.dispatch(changeInitTempAction(e.target.value));
    }
  }

  /*
   * ポンプ変更
   * @param {Event} e イベント情報
   * @since ando 2023-08-07
   */
  checkIdoPram(e, id) {
    console.log(id);
    const value = e.target.value;
    setTimeout(() => {
      switch (id) {
        case "mr": //モデル半径
          if (this.checkInput(value, "モデル半径", 100, 1000)) {
            return this.props.dispatch(changeMeshRadiusAction(value));
          } else {
            //return this.props.dispatch(changeMeshRadiusAction(this.props.meshRadius));
            return this.props.dispatch(changeMeshRadiusAction(500));
          }
        case "mv": //周方向分割数
          if (this.checkInput(value, "周方向分割数", 12, 36, true)) {
            return this.props.dispatch(changeMeshVertexAction(value));
          } else {
            //return this.props.dispatch(changeMeshVertexAction(this.props.meshVertex));
            return this.props.dispatch(changeMeshVertexAction(18));
          }
        case "ms": //半径方向分割数
          if (this.checkInput(value, "半径方向分割数", 4, 10, true)) {
            return this.props.dispatch(changeMeshSplitAction(value));
          } else {
            //return this.props.dispatch(changeMeshSplitAction(this.props.meshSplit));
            return this.props.dispatch(changeMeshSplitAction(5));
          }
        case "msz": //鉛直方向分割数
          if (this.checkInput(value, "鉛直方向分割数", 20, 40, true)) {
            return this.props.dispatch(changeMeshZSplitAction(value));
          } else {
            //return this.props.dispatch(changeMeshZSplitAction(this.props.meshZSplit));
            return this.props.dispatch(changeMeshZSplitAction(20));
          }
        case "mb": //半径方向バイアス
          if (this.checkInput(value, "半径方向バイアス", 1, 10)) {
            return this.props.dispatch(changeMeshBiasAction(value));
          } else {
            //return this.props.dispatch(changeMeshBiasAction(this.props.meshBias));
            return this.props.dispatch(changeMeshBiasAction(5));
          }

        case "ar": //井戸寸法半径
          if (this.checkInput(value, "井戸寸法半径", 0.01, 10)) {
            return this.props.dispatch(changeAnalyRadiusAction(value));
          } else {
            //return this.props.dispatch(changeAnalyRadiusAction(this.props.analyRadius));
            return this.props.dispatch(changeAnalyRadiusAction(0.1));
          }

        case "ah": //井戸寸法下端深度
          if (this.checkInput(value, "井戸半径下端深度", 0, 1000)) {
            return this.props.dispatch(changeAnalyBHHeightAction(value));
          } else {
            //return this.props.dispatch(changeAnalyBHHeightAction(this.props.analyBHHeight));
            return this.props.dispatch(changeAnalyBHHeightAction(150));
          }

        case "ap": //ポンプ位置深度
          if (this.checkInput(value, "ポンプ位置深度", 0, 1000)) {
            return this.props.dispatch(changeAnalyPumpAction(value));
          } else {
            //return this.props.dispatch(changeAnalyPumpAction(this.props.analyPump));
            return this.props.dispatch(changeAnalyPumpAction(150));
          }

        case "aw": //初期水位
          if (this.checkInput(value, "初期水位", 0, 1000)) {
            return this.props.dispatch(changeAnalyWLAction(value));
          } else {
            //return this.props.dispatch(changeAnalyWLAction(this.props.analyWL));
            return this.props.dispatch(changeAnalyWLAction(55));
          }
        case "tp": //揚水量
          if (this.checkInput(value, "目標揚水量", 0.01, 20000)) {
            return this.props.dispatch(changePompAmountAction(value));
          } else {
            //return this.props.dispatch(changePompAmountAction(this.props.pompAmount));
            return this.props.dispatch(changePompAmountAction(5));
          }
        case "tw": //水位低下量
          if (this.checkInput(value, "目標水位低下量", 0.01, 100)) {
            return this.props.dispatch(changeWLDAmountAction(value));
          } else {
            //return this.props.dispatch(changeWLDAmountAction(this.props.wldAmount));
            return this.props.dispatch(changeWLDAmountAction(5));
          }
        case "mml": //マップドメッシュ化層番号：
          if (this.checkInput(value, "マップドメッシュ化層番号", 0, 100, true)) {
            return this.props.dispatch(changeMapMeshLayAction(value));
          } else {
            //return this.props.dispatch(changeMapMeshLayAction(this.props.mapMeshLay));
            return this.props.dispatch(changeMapMeshLayAction(3));
          }
        case "szs": //スクリーン補正鉛直分割数：
          if (this.checkInput(value, "スクリーン補正鉛直分割数", 0, 10, true)) {
            return this.props.dispatch(changeScreenZSplitAction(value));
          } else {
            //return this.props.dispatch(changeScreenZSplitAction(this.props.screenZSplit));
            return this.props.dispatch(changeScreenZSplitAction(1));
          }
        case "pt": //推定確率閾値(%)
          if (this.checkInput(value, "推定確率閾値", 0.1, 100)) {
            return this.props.dispatch(changeProbThresholdAction(value));
          } else {
            //return this.props.dispatch(changeProbThresholdAction(this.props.probThreshold));
            return this.props.dispatch(changeProbThresholdAction(30));
          }
        case "wsAr": //流域界モデル井戸半径
          if (this.checkInput(value, "流域界モデル井戸半径", 1, 25)) {
            return this.props.dispatch(changeWsArAction(value));
          } else {
            //return this.props.dispatch(changeWsArAction(this.props.wsAr));
            return this.props.dispatch(changeWsArAction(5));
          }
        case "bud": //予算
          if (this.checkInput(value, "予算（円）", 100000, 10000000)) {
            return this.props.dispatch(changeBudgetAction(value));
          } else {
            return this.props.dispatch(changeBudgetAction(1000000));
          }
        case "uc": //メートル単価
          if (this.checkInput(value, "メートル単価（円）", 5000, 100000)) {
            return this.props.dispatch(changeUnitCostAction(value));
          } else {
            return this.props.dispatch(changeUnitCostAction(10000));
          }
        case "deltaT": //デルタt
          if (this.checkInput(value, "⊿T", 0.001, 100)) {
            return this.props.dispatch(changeDeltaTAction(value));
          } else {
            return this.props.dispatch(changeDeltaTAction(0.01));
          }
        case "initTemp": //地盤初期温度(℃)
          if (this.checkInput(value, "地盤初期温度", 0, 50)) {
            return this.props.dispatch(changeInitTempAction(value));
          } else {
            return this.props.dispatch(changeInitTempAction(12));
          }
      }
    }, 100);
  }
  /*
   * 表示/非表示を切り替える
   * @since ando 2023-08-08
   */
  changeVisible(e, id) {
    const div1 = document.getElementById(id);
    if (div1.style.display == "block") {
      // noneで非表示
      div1.style.display = "none";
    } else {
      // blockで表示
      div1.style.display = "block";
    }
  }
  /*
   * 追加
   * @since ando 2023-8-10
   */
  addCat(type) {
    if (type == 0) {
      this.props.dispatch(addPompTrAction(this.props.pompTrData.length + 1));
    } else {
      this.props.dispatch(addScreenTrAction(this.props.screenTrData.length + 1));
    }
  }

  /*
   * 削除
   * @since ando 2023-8-10
   */
  delCat(type) {
    if (type == 0) {
      console.log("delete");
      this.props.dispatch(delPompTrAction(this.props.pompTrData.length - 1));
    } else {
      this.props.dispatch(delScreenTrAction(this.props.screenTrData.length - 1));
    }
  }

  /*
   * 行削除
   * @since ando 2024-03-27
   */
  deleteSel() {
    // 指定されたインデックスの行を除外して新しい wellsTrData 配列を作成する
    const updatedPompTrData = this.props.pompTrData.filter((el, i) => i != this.props.pompTrSelRow);

    const updatedPompTrDataWithNewIds = updatedPompTrData.map((el, i) => ({
      ...el,
      ID: i + 1, // 新しいidを振り直す
    }));

    // 新しい wellsTrData をセット
    this.props.dispatch(updatePompTrAction(updatedPompTrDataWithNewIds));
  }

  /*
   * テーブルデータ書き換え
   * @since ando 2024-07-29
   */
  changeField = (e, index, field) => {
    // 例えば、選択された種別を取得する処理などを追加
    const changeField = e.target.value;
    if (isNaN(changeField)) {
      alert("数値を入力してください。");
      return;
    }
    const updatedWsLakeTrData = this.props.lakeTrData.map((el, i) => {
      if (i === index) {
        return { ...el, [field]: changeField };
      }
      return el;
    });
    this.props.dispatch(updateLakeTrAction(updatedWsLakeTrData));
  };

  /*
   * 表示/非表示を切り替える
   * @since ando 2023-08-08
   */
  openBoringEditor(id) {
    this.props.dispatch(openEditerAction("1-1"));
  }

  /*
   * クリック位置と予測位置を確認する
   * @since ando 2024-06-01
   */
  checkCenterPoint() {
    if (window.getAP()[0] == 0 && window.getAP()[1] == 0 && this.props.autoScrChk == false && this.props.modelKind != 2) {
      if (window.confirm("スクリーン位置を設定していない場合、オールスクリーンで解析条件が設定されます。連動を実行しても良いですか？")) {
        return true;
      } else {
        return false;
      }
    } else if (window.getCP()[0].toFixed(6) == window.getAP()[0] && window.getCP()[1].toFixed(6) == window.getAP()[1]) {
      return true;
    } else if (window.getAP()[0] != 0) {
      //予測実行している場合
      if (window.confirm("クリック位置と井戸予測位置が異なります。連動を実行しても良いですか。")) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  /*
   * 目標量のラジオボタンを判定する
   * @since ando 2023-08-07
   */
  checkTarget(t) {
    if (this.props.analyTarget == t) {
      return true;
    } else {
      return false;
    }
  }

  /*
   * モデル種別を判定する
   * @since ando 2023-08-07
   */
  checkModelKind(t) {
    if (this.props.modelKind == t) {
      return true;
    } else {
      return false;
    }
  }

  /*
   * モデルのラジオボタンを判定する
   * @since ando 2023-08-07
   */
  checkModel(t) {
    if (t == "cr") {
      console.log(this.props.modelKind);
      if (this.props.modelKind == 1) {
        return "checked";
      } else {
        return "";
      }
    } else if (t == "su") {
      if (this.props.modelKind == 2) {
        return "checked";
      } else {
        return "";
      }
    } else {
      if (this.props.modelKind == 3) {
        return "checked";
      } else {
        return "";
      }
    }
  }

  /*
   * 入力値チェック
   * @param {Event} e イベント情報
   * @since ando 2023-08-07
   */
  checkInput(v, str, min, max, isInteger) {
    if (isNaN(v)) {
      alert(str + "は半角数字を入力してください。");
      return false;
    } else if (isInteger) {
      if (!Number.isInteger(Number(v))) {
        alert(str + "は整数を入力してください。");
        return false;
      } else if (v.indexOf(".") != -1) {
        alert(str + "は小数点を含む値を入力できません。");
        return false;
      } else if (!(v >= min && v <= max)) {
        alert(str + "は" + min + "以上、" + max + "以下で入力してください。");
        return false;
      } else {
        return true;
      }
    } else if (!(v >= min && v <= max)) {
      alert(str + "は" + min + "以上、" + max + "以下で入力してください。");
      return false;
    } else {
      return true;
    }
  }

  /*
   * ボーリング数チェック
   * @param {Event} e イベント情報
   * @since ando 2023-08-07
   */
  checkBoringNum() {
    if (this.props.modelKind == 3) {
      let num = window.cntWSAreaBoring(window.getSelectedWaterShed().selectedFeaturesCoord);
      if (num < 1) {
        return false;
      } else {
        return true;
      }
    } else {
      let num = window.cntAreaBoring(window.getmodelAreaCoord()[0], window.getmodelAreaCoord()[1], window.getmodelAreaCoord()[2], window.getmodelAreaCoord()[3]);
      //console.log(num)
      //最近傍井戸のチェックが入っていた場合、自身は除くため2本以上必要
      if (this.props.crossValid == 1) {
        if (num < 2) {
          alert("最近傍井戸を除外している場合、学習領域内に2本以上のボーリングが必要です。");
          return false;
        } else {
          return true;
        }
      } else {
        if (num < 1) {
          alert("学習領域が存在しないか学習領域内のボーリングが不足しています。");
          return false;
        } else {
          return true;
        }
      }
    }
  }

  /*
   * パラメータチェック
   * @param {Event} e イベント情報
   * @since ando 2023-08-07
   */
  checkParam() {
    if (isNaN(this.props.meshRadius)) {
      alert("モデル半径を入力してください。");
      return false;
    } else if (isNaN(this.props.meshVertex)) {
      alert("周方向分割数を入力してください。");
      return false;
    } else if (isNaN(this.props.meshSplit)) {
      alert("平面分割数を入力してください。");
      return false;
    } else if (isNaN(this.props.meshBias)) {
      alert("バイアスを入力してください");
      return false;
    } else if (isNaN(this.props.wldAmount) && isNaN(this.props.pompAmount)) {
      alert("目標量を入力してください");
      return false;
    } else {
      return true;
    }
  }

  /*
   * 重なったポリゴンがないかチェック
   */
  isPointInPolygon(point, polygon) {
    const zero = Number.MIN_VALUE;
    const intersect = (p1, p2, p3, p4) => {
      //重なった点がないか調べる
      if ((Math.abs(p1[0] - p3[0]) < zero && Math.abs(p1[1] - p3[1]) < zero) || (Math.abs(p1[0] - p4[0]) < zero && Math.abs(p1[1] - p4[1]) < zero) || (Math.abs(p2[0] - p3[0]) < zero && Math.abs(p2[1] - p3[1]) < zero) || (Math.abs(p2[0] - p4[0]) < zero && Math.abs(p2[1] - p4[1]) < zero))
        return false;
      //交点が他の点と重なっていないか調べる
      let p = getIntersectPoint(p1, p2, p3, p4);
      if (p === null) return false;
      if ((Math.abs(p[0] - p1[0]) < zero && Math.abs(p[1] - p1[1]) < zero) || (Math.abs(p[0] - p2[0]) < zero && Math.abs(p[1] - p2[1]) < zero) || (Math.abs(p[0] - p3[0]) < zero && Math.abs(p[1] - p3[1]) < zero) || (Math.abs(p[0] - p4[0]) < zero && Math.abs(p[1] - p4[1]) < zero)) return false;
      //直線上に並んでいないか調べる
      if (Math.abs(p1[0]) - Math.abs(p3[0]) < zero && Math.abs(p1[1]) - Math.abs(p3[1]) < zero && Math.abs(p2[0]) - Math.abs(p4[0]) < zero && Math.abs(p2[1]) - Math.abs(p4[1]) < zero) return false;
      if (Math.abs(p1[0]) - Math.abs(p4[0]) < zero && Math.abs(p1[1]) - Math.abs(p4[1]) < zero && Math.abs(p2[0]) - Math.abs(p3[0]) < zero && Math.abs(p2[1]) - Math.abs(p3[1]) < zero) return false;
      return true;
    };
    const getIntersectPoint = (p1, p2, p3, p4) => {
      if ((Math.abs(p1[0] - p2[0]) < zero && Math.abs(p1[1] - p2[1]) < zero) || (Math.abs(p3[0] - p4[0]) < zero && Math.abs(p3[1] - p4[1]) < zero)) {
        return null;
      }
      let v1 = [p1[0] - p3[0], p1[1] - p3[1]];
      let vA = [p2[0] - p1[0], p2[1] - p1[1]];
      let vB = [p4[0] - p3[0], p4[1] - p3[1]];

      let deno = vA[0] * vB[1] - vA[1] * vB[0];
      if (deno === 0) return null;

      let t = (v1[1] * vB[0] - v1[0] * vB[1]) / deno;
      let s = (v1[1] * vA[0] - v1[0] * vA[1]) / deno;
      if (t < 0 || 1 < t || s < 0 || 1 < s) return null;

      return [vA[0] * t + p1[0], vA[1] * t + p1[1]];
    };

    let points = Array.from(polygon);
    points.push(polygon[0]);
    let xCount = 0,
      yCount = 0;
    let maxX = -Number.MAX_VALUE,
      maxY = -Number.MAX_VALUE;
    points.forEach(el => {
      if (el[0] > maxX) maxX = el[0];
      if (el[1] > maxY) maxY = el[1];
    });

    let p1 = point;
    let p2 = [point[0] + maxX, point[1]];
    for (let i = 0; i < points.length - 1; i++) {
      let p3 = points[i];
      let p4 = points[i + 1];
      if (intersect(p1, p2, p3, p4)) xCount++;
    }

    p2 = [point[0], point[1] + maxY];
    for (let i = 0; i < points.length - 1; i++) {
      let p3 = points[i];
      let p4 = points[i + 1];
      if (intersect(p1, p2, p3, p4)) yCount++;
    }
    if (xCount % 2 === 1 && yCount % 2 === 1) return true;
    else return false;
  }

  /*
   *  井戸すべてが流域界に含まれるか確認する関数
   */
  checkShedsIncludeWells(sheds, wells) {
    let count = 0;
    wells.forEach(well => {
      sheds.forEach(shed => {
        if (this.isPointInPolygon(well, shed)) {
          count++;
          return;
        }
      });
    });
    return count === wells.length;
  }

  /*
   *  流域界が離れていないかを確認する関数
   */
  checkShedsNotSeparated(sheds) {
    let count = 0;
    let check = new Array(sheds.length).fill(false);
    check[0] = true;
    sheds.forEach((el, index) => {
      sheds[index] = [...new Set(el.map(JSON.stringify))].map(JSON.parse);
    });

    for (let count = 0; count < sheds.length; count++) {
      let coords = [];
      check.forEach((_, i) => {
        if (check[i]) sheds[i].forEach(shed => coords.push(shed));
      });
      coords = [...new Set(coords.map(JSON.stringify))].map(JSON.parse);
      check.forEach((skip, i) => {
        let c = 0;
        if (skip) return;
        let shed = sheds[i];
        coords.forEach(coord => {
          for (let j = 0; j < shed.length; j++) {
            let dist = ((coord[0] - shed[j][0]) ** 2 + (coord[1] - shed[j][1]) ** 2) ** 0.5;
            if (dist === 0) {
              c++;
              if (c > 1) check[i] = true;
            }
          }
        });
      });
    }
    check.forEach(c => {
      if (c) count++;
    });
    return count === sheds.length;
  }

  /*
   *  流域界のminX,minY,maxX,maxYとmodelAreaを比較してサーバーに送るデータセットレンジを定める。
   */
  retWSDataset(sheds) {
    let x = [];
    let y = [];
    let ml = window.getmodelAreaCoord();
    sheds.forEach(shed => {
      shed.forEach(sh => {
        x.push(sh[0]);
        y.push(sh[1]);
      });
    });
    const aryMax = function (a, b) {
      return Math.max(a, b);
    };
    const aryMin = function (a, b) {
      return Math.min(a, b);
    };
    let ary = [5, 2, 3, 1, 10];
    let minX = x.reduce(aryMin);
    let minY = y.reduce(aryMin);
    let maxX = x.reduce(aryMax);
    let maxY = y.reduce(aryMax);

    let x1 = 0;
    let x2 = 0;
    let y1 = 0;
    let y2 = 0;
    x1 = minX - 0.01;
    y1 = minY - 0.01;
    x2 = maxX + 0.01;
    y2 = maxY + 0.01;
    /*
        if (ml[2] < minX) {
            x1 = ml[2]
        } else {
            x1 = minX - 0.01
        }

        if (ml[1] < minY) {
            y1 = ml[1]
        } else {
            y1 = minY - 0.01
        }

        if (ml[3] > maxX) {
            x2 = ml[3]
        } else {
            x2 = maxX + 0.01
        }

        if (ml[0] > maxY) {
            y2 = ml[0]
        } else {
            y2 = maxY + 0.01
        }
        */
    return [x1, x2, y1, y2];
  }

  /*
   *  揚水井の揚水量が0でないか確認する
   * @since ando 2024-10-17
   */
  checkZeroWellsPomo(trData) {
    let cz = true;
    trData.forEach(tr => {
      if (tr.KIND == "type1" && parseFloat(tr.PA) <= 0) {
        cz = false;
      }
    });
    return cz;
  }
  /*
   * 透水係数最適化対象のボーリング名を取得する。
   * @since ando 2024-10-18
   */
  getTargetBor() {
    if (this.props.chkK != null) {
      console.log(this.props.chkK);
      return this.props.chkK[2].ido_ID;
    } else {
      return "未選択";
    }
  }
  /*
   * IDとパスワードからジオモデラーのURLを生成する。
   * @since ando 2023-06-18
   */
  createGMURL() {
    //return '?u_id='+this.props.id+'&u_num=0&u_pass='+this.props.pass
    return "?u_id=" + "gmai" + "&u_num=0&u_pass=" + "gmai&wl_id=" + this.props.id;
  }

  /*
   *予測されていない井戸がないか確認する
   * @since ando 2025-03-24
   */
  checKPredWells() {
    for (let i = 0; i < this.props.wellsTrData.length; i++) {
      if (this.props.wellsTrData[i].PREDATA == undefined) {
        return true;
      } else {
      }
    }
    return false;
  }

  /*
   *湖沼水位が入力されているかを確認する
   * @since ando 2025-03-24
   */
  checLakeWl() {
    const hasNumber = this.props.lakeTrData.some(el => {
      const wl = el.wl;
      return wl !== "" && wl !== null && !isNaN(Number(wl));
    });
    return hasNumber;
  }

  downloadImage(url, filename) {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  async setPict(i) {
    this.props.dispatch(showRegionModelWindowAction(true));
    this.props.dispatch(showInputTempWindowAction(false));
    this.props.dispatch(changeCheckPreIndAction(i));
    this.props.dispatch(changeNewDsAction(this.props.boringDs));
    this.props.dispatch(openEstBoringAction(Math.random()));
  }

  async finPict() {
    this.props.dispatch(showInputTempWindowAction(false));
    this.props.dispatch(openEstBoringAction(null));
    this.props.dispatch(showRegionModelWindowAction(false));
  }

  /*
   * GEOModelerを開く
   * @param
   */
  async linkGM() {
    this.modelAreaCoord = window.getmodelAreaCoord();
    this.props.csLineDs.forEach(ID => {
      this.tmpLst = [];
      this.tmpLst.push(ID.ID);
      ID.coords.forEach(coord => {
        this.tmpLst.push(coord[1]);
        this.tmpLst.push(coord[2]);
      });
      this.csIDCoordlst.push(this.tmpLst);
    });
    this.scrList = [];
    this.conList = [];
    const result = window.getSelectedWaterShed();
    let selectedFeaturesCoord;
    let selectedFeaturesMap;
    if (this.props.optWS && this.props.wellsTrData.length != 0) {
      const selected = window.getALLWaterShed([(this.modelAreaCoord[2] + this.modelAreaCoord[3]) / 2, (this.modelAreaCoord[0] + this.modelAreaCoord[1]) / 2], result);
      selectedFeaturesCoord = selected.selectedFeaturesCoord;
      selectedFeaturesMap = selected.selectedFeaturesMap;
    } else {
      selectedFeaturesCoord = result.selectedFeaturesCoord;
      selectedFeaturesMap = result.selectedFeaturesMap;
    }

    if (this.boringID1 != undefined && this.boringID2 != undefined) {
      this.boring = this.props.newDs[this.boringID1].data[this.boringID2];
      let preDepThk = 0;
      if (this.boring.geo.length) {
        //geoが空でない場合
        this.boring.geo.forEach((el, index) => {
          const sel = this.props.geoDs[0].geo[el[1] - 1]; //現在は13分類のみ
          let depTd;
          let thkTd;
          let scrTd;
          let conTd;
          let thk;

          if (this.props.newDs[this.boringID1].depThkRdo === "dep") {
            //深度の場合
            thk = el[0] - preDepThk;
            depTd = el[0].toFixed(2);
            thkTd = Math.abs(thk).toFixed(2);
            preDepThk = el[0];
          } else {
            //層厚の場合
            thk = el[0];
            depTd = Math.abs(el[0] + preDepThk).toFixed(2);
            thkTd = thk.toFixed(2);
            preDepThk += el[0];
          }
          scrTd = this.boring.screen[index][0];
          if (scrTd) {
            this.scrList.push(String(depTd - thkTd));
            this.scrList.push(String(depTd));
            this.scrList.push(sel.ID);
          }
          let con = this.boring.con[index];
          this.conList.push({
            thickness: thkTd,
            unit_weight: Number(con[0]),
            s_coeff: 0,
            c_coeff: con[1] ? Number(con[2]) : 0,
            void_ratio: con[1] ? Number(con[3]) : 0,
          });
        });
      }
    } else {
      this.scrList = [];
    }

    //流域界モデルの時、流域界がはみでていないかを確認して、はみ出ていた場合rangeを補正する値をいれる。
    let dr;
    if (this.props.modelKind == 3) {
      //流域界モデル

      dr = this.retWSDataset(selectedFeaturesCoord);
      //EP用
      /*
            console.log('------------井戸座標出力------------')
            console.log('緯度：' + this.props.wellsTrData[0].LAT)
            console.log('経度：' + this.props.wellsTrData[0].LON)


            console.log('------------スクリーン位置出力------------')
            if (this.props.wellsTrData[0].PREDATA != undefined) {
                console.log(this.props.wellsTrData[0].PREDATA.screen)
            } else {
                console.log('スクリーンが設定されていません。')
            }
            */
    } else if (this.props.analyType == 5 || this.props.analyType == 6) {
      let DEF_MODEL_AREA = window.getDefModelArea();
      dr = [this.props.chkK[2].lon - DEF_MODEL_AREA[0], this.props.chkK[2].lon + DEF_MODEL_AREA[0], this.props.chkK[2].lat - DEF_MODEL_AREA[1], this.props.chkK[2].lat + DEF_MODEL_AREA[1]];
    } else {
      let tmp = window.getmodelAreaCoord();
      dr = [tmp[2], tmp[3], tmp[1], tmp[0]];
      //EP用
      /*
            console.log('------------井戸中心座標出力------------')
            console.log('緯度：' + window.getCP()[1])
            console.log('経度：' + window.getCP()[0])


            console.log('------------スクリーン位置出力------------')
            console.log(this.scrList)
            */
    }
    if (this.props.chkK == null || this.props.chkK == undefined) {
      this.props.dispatch(changeChkKAction([0, 0, 0]));
    }

    //複数井戸のキャプチャ
    await window.initBorEdiURLs();
    //await window.setBorsCaptFlag(true);
    for (let i = 0; i < this.props.wellsTrData.length; i++) {
      if (this.props.wellsTrData[i].PREDATA == undefined) {
      } else {
        await this.setPict(i);
        if ((await window.captureBorsEditor(false, i)) == false) {
          alert("画像取得に失敗しました。お手数ですが再度、連動ボタンを実行してください");
          await this.finPict();
          this.waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
          return;
        }
        await this.finPict();
      }
    }
    await window.setBorsCaptFlag(false);
    console.log(window.getBorEdiURL());

    const data = {
      //pict:window.getBorEdiURL(),
      pict: this.props.editerSw == false ? await window.getBorEdiURL() : await window.captureBorEditor(),
      picts: window.getBorEdiURLs(),
      zoom: window.getZoom(),
      csLine: -1,
      csIDCoord: (this.csIDCoordlst = []),
      range: {
        x1: dr[0],
        x2: dr[1],
        y1: dr[2],
        y2: dr[3],
        rp: this.props.crossValid == 0 ? "none" : window.getModelMarkerNearPoint(),
      },
      type: "well",
      gmWellData: {
        cp: window.getCP(),
        mr: this.props.meshRadius == undefined ? null : this.props.meshRadius,
        mv: this.props.meshVertex == undefined ? null : this.props.meshVertex,
        ms: this.props.meshSplit == undefined ? null : this.props.meshSplit,
        msz: this.props.meshZSplit == undefined ? null : this.props.meshZSplit,
        mb: this.props.meshBias == undefined ? null : this.props.meshBias,
        ar: this.props.analyRadius == undefined ? null : this.props.analyRadius,
        ah: this.props.analyBHHeight == undefined ? null : this.props.analyBHHeight,
        ap: this.props.analyPump == undefined ? null : this.props.analyPump,
        aw: this.props.analyWL == undefined ? null : this.props.analyWL,
        at: this.props.analyTarget == undefined ? null : this.props.analyTarget,
        tp: this.props.pompAmount == undefined ? null : this.props.pompAmount,
        tw: this.props.wldAmount == undefined ? null : this.props.wldAmount,
        mk: this.props.modelKind == undefined ? null : this.props.modelKind,
        mml: this.props.mapMeshLay == undefined ? null : this.props.mapMeshLay,
        szs: this.props.screenZSplit == undefined ? null : this.props.screenZSplit,
        ep: this.props.equPermCheck == undefined ? null : this.props.equPermCheck,
        pt: this.props.probThreshold == undefined ? null : this.props.probThreshold,
        scl: this.scrList,
        con: this.conList,
        id: this.props.id,
        wsar: this.props.wsAr == undefined ? null : this.props.wsAr,
        wells: this.props.modelKind == 3 ? this.props.wellsTrData : null,
        ws: this.props.modelKind == 3 ? selectedFeaturesMap : null,
        sd: this.props.sameDepth,
        asc: this.props.autoScrChk,
        alt: this.props.analyType,
        cm: this.props.considerMat,
        ptd: this.props.pompTrData,
        msn: this.props.maxScrNum,
        bud: this.props.budget,
        uc: this.props.unitCost,
        geo: this.props.geoDs[0].geo,
        wstdts: this.props.editerWlMeaData === undefined || this.props.editerWlMeaData[this.props.chkK[0]] === undefined || this.props.editerWlMeaData[this.props.chkK[0]][this.props.chkK[1]] === undefined ? [] : this.props.editerWlMeaData[this.props.chkK[0]][this.props.chkK[1]],
        ptdts:
          this.props.analyType == 9
            ? this.props.editerPompMeaData[this.props.preWL - 1][0]
            : this.props.editerPompMeaData === undefined || this.props.editerPompMeaData[this.props.chkK[0]] === undefined || this.props.editerPompMeaData[this.props.chkK[0]][this.props.chkK[1]] === undefined
              ? []
              : this.props.editerPompMeaData[this.props.chkK[0]][this.props.chkK[1]],
        deltaT: this.props.deltaT,
        otdts: this.props.outTimeTrData,
        wsLakeTr: this.props.lakeTrData,
        initTemp: this.props.initTemp,
      },
      bor: this.props.chkK[2],
    };

    const origin = window.location.origin;
    const search = window.location.search;
    await fetch(`/api/linkGM/${search}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then(res => res.json())
      .then(res => {
        if (res.result == "limit") {
          alert("連動実行回数の上限に達したため、実行できません。");
          this.waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
          return;
        }
        console.log("doExe done");
        this.waiting(false);
        this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
      })
      .catch(err => {
        console.log(err.message);
        alert("サーバーエラー。");
        this.waiting(false);
        this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
      });
  }

  /*
   * サブウィンドウを閉じる
   * @since hara 2020-09-09
   */
  closeSw() {
    console.log(this.props.regionModelWindowVisible);
    if (window.existModelArea()) {
      //入力データをチェック
      let keys = 0;

      //クリック位置からエリアを特定
      for (let key in this.props.paramRegion) {
        const coord = this.props.paramRegion[key].range;
        if (coord["x1"] < window.getCP()[0] && coord["y1"] < window.getCP()[1] && coord["x2"] > window.getCP()[0] && coord["y2"] > window.getCP()[1]) {
          keys = key;
        }
      }
      this.props.dispatch(changeCoordAction(window.getModelAreaCoord()));
      this.props.dispatch(openSwAction(null));
      this.props.dispatch(changeSwModeAction(0));
      this.props.dispatch(changeEditerModeAction(0));
      this.props.dispatch(openEstBoringAction(null));
      this.props.dispatch(showMeaTimeWindowAction(false));
      window.changeShowData("ws", false);
      window.endSelectWaterShed();
      window.endMultiWells();
      window.endModelArea(false);
      window.setBoringID();
    } else {
      this.props.dispatch(openSwAction(null));
      this.props.dispatch(changeSwModeAction(0));
      this.props.dispatch(changeEditerModeAction(0));
      this.props.dispatch(openEstBoringAction(null));
      this.props.dispatch(showMeaTimeWindowAction(false));
      window.changeShowData("ws", false);
      window.endSelectWaterShed();
      window.endMultiWells();
      window.endModelArea(false);
    }
    window.removeRegionLay();
    window.setDrawingFlag(false);
    this.props.dispatch(changePompTrSelRowAction(null));
  }

  /*
   * GM-WELL連動
   * @since ando 2023-08-07
   */
  async doExe() {
    //入力データをチェック
    //学習領域内のボーリング数をチェック
    await this.doCheckExe();
    if (this.checkParam()) {
      switch (Number(this.props.modelKind)) {
        case 1: //影響圏半径モデル
          if (this.props.analyType == 5 || this.props.analyType == 6) {
            //透水係数最適解析
            if (this.props.chkK != null) {
              this.props.dispatch(changeEditerModeAction(0));
              window.checkSpeed("通信速度が低速です。アプリケーションの処理が正常に完了しない可能性がございます。", 7000);
              setTimeout(() => window.open(this.props.gmUrl), 750);
              setTimeout(() => this.doLearn(false), 50);
            } else {
              alert("最適化に使用するボーリングを選択してください。");
            }
          } else {
            if (this.checkBoringNum()) {
              if (this.checkCenterPoint()) {
                //クリック位置と予測位置が変わっていないか確認する
                if (window.existModelArea()) {
                  if (this.props.analyType == 11) {
                    //非定常解析の場合、出力時間のチェック
                    if (this.props.outTimeTrData.length == 0 || this.props.outTimeTrData == undefined) {
                      alert("出力時間を設定してください。");
                    } else {
                      this.props.dispatch(changeCoordAction(window.getModelAreaCoord()));
                      this.props.dispatch(changeEditerModeAction(0));
                      window.checkSpeed("通信速度が低速です。アプリケーションの処理が正常に完了しない可能性がございます。", 7000);
                      setTimeout(() => window.open(this.props.gmUrl), 750);
                      setTimeout(() => this.doLearn(false), 50);
                    }
                  } else if (this.props.analyType == 9) {
                    //地域別補正計算　計測揚水量のチェック
                    if (this.props.editerPompMeaData[this.props.preWL - 1] != undefined) {
                      if (this.props.editerPompMeaData[this.props.preWL - 1][0].length != 0) {
                        this.props.dispatch(changeCoordAction(window.getModelAreaCoord()));
                        this.props.dispatch(changeEditerModeAction(0));
                        window.checkSpeed("通信速度が低速です。アプリケーションの処理が正常に完了しない可能性がございます。", 7000);
                        setTimeout(() => window.open(this.props.gmUrl), 750);
                        setTimeout(() => this.doLearn(false), 50);
                      } else {
                        alert("計測揚水量を登録してください");
                      }
                    } else {
                      alert("計測揚水量を登録してください");
                    }
                  } else {
                    this.props.dispatch(changeCoordAction(window.getModelAreaCoord()));
                    this.props.dispatch(changeEditerModeAction(0));
                    window.checkSpeed("通信速度が低速です。アプリケーションの処理が正常に完了しない可能性がございます。", 7000);
                    setTimeout(() => window.open(this.props.gmUrl), 750);
                    setTimeout(() => this.doLearn(false), 50);
                  }
                } else {
                  alert("井戸位置を指定してください。");
                }
              }
            }
          }
          break;
        case 3: //流域界モデル
          let selectSheds = window.getSelectedWaterShed().selectedFeaturesCoord;
          let wellPoints = window.getWellsPoints();

          if (this.props.wellsTrData == undefined || this.props.wellsTrData.length == 0) {
            if (this.props.analyType != 1 && this.props.analyType != 2) {
              alert("複数井戸を作成してください。");
            } else {
              if (!this.checkShedsIncludeWells(selectSheds, [[window.getCP()[0], window.getCP()[1]]])) {
                alert("井戸位置に流域界が存在しません。柱状図予測で井戸位置を変更するか流域界を選択してください。");
              } else if (!this.checkBoringNum()) {
                alert("学習に必要なボーリングが不足しています。");
              } else if (window.getCP()[0] == 0) {
                alert("井戸位置を作成してください。");
              } else if (this.props.lakeTrData.length > 0 && !this.checLakeWl()) {
                alert("流域界内に湖沼が含まれています。水位を入力してください。");
              } else {
                window.open(this.props.gmUrl);
                setTimeout(() => this.doLearn(false), 50);
              }
            }
          } else {
            if (!this.checkBoringNum()) {
              alert("学習に必要なボーリングが不足しています。");
            } else if (!window.checkPointsDist(window.getLimitWellDist())) {
              alert("井戸間の距離を" + window.getLimitWellDist() + "m以下にしてください。");
            } else if (wellPoints.length == 0 && this.props.analyType != 1) {
              alert("井戸位置を作成してください。");
            } else if (selectSheds.length > 5) {
              alert("流域界は5つまで選択できます。");
            } else if (!this.checkShedsIncludeWells(selectSheds, wellPoints)) {
              alert("流域界に含まれていない井戸が存在します。");
            } else if (!this.checkShedsNotSeparated(selectSheds)) {
              alert("流域界が離れています");
            } else if ((this.props.analyType == 2 || this.props.analyType == 3 || this.props.analyType == 11) && !this.checkZeroWellsPomo(this.props.wellsTrData)) {
              //揚水井or揚水井・還元井解析の場合、揚水量が0となっていないか確認する。
              alert("揚水井解析を行う場合、揚水量を0より多く入力してください。");
            } else if (this.checKPredWells()) {
              //予測されていない井戸が存在する場合
              alert("予測されていない井戸が存在します。予測実行してください。");
            } else if (this.props.lakeTrData.length > 0 && !this.checLakeWl()) {
              alert("流域界内に湖沼が含まれています。水位を入力してください。");
            } else {
              window.open(this.props.gmUrl);
              setTimeout(() => this.doLearn(false), 50);
            }
          }

          break;
      }
    }
  }

  /*
   * 全流域界選択解除
   * @since ando 2024-04-18
   */
  deleteSelectedWaterShed() {
    if (window.confirm("流域界の選択を初期化してよろしいですか。")) {
      window.deleteSelectedWaterShed();
      //クリック位置に含まれる流域界を選択する。
      window.getCPWaterShed(window.getCP());
      //学習領域を流域界の範囲にする
      const selectedWScoords = window.getSelectedWaterShed().selectedFeaturesCoord;
      this.props.dispatch(updateLakeTrAction(window.syncLakeTrData(this.props.lakeTrData, window.getWsLakes())));
      if (selectedWScoords.length != 0) {
        const newModelArea = window.retWSDataset(selectedWScoords);
        window.changeModelArea(newModelArea[2], newModelArea[3], newModelArea[0], newModelArea[1], true);
      }
    }
  }

  handleKeyDown = event => {
    if (event.key == "Delete" && this.props.waterShedSelectable) {
      if (window.confirm("全流域界の選択を解除してよろしいですか。")) {
        window.deleteSelectedWaterShed();
      }
    }
  };

  /*
   * 実行可否を確認
   * @since ando 2025-07-31
   */
  async doCheckExe() {
    const origin = window.location.origin;
    const search = window.location.search;

    try {
      const res = await fetch(`${origin}/api/0/checkExe/${search}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "estBoring",
        }),
      });

      const json = await res.json();
      console.log("res", json);

      if (json.result === "OK") {
        return true; // 処理可能
      } else {
        this.props.dispatch(changeWaitngTimeAction(json.waiting_time));
        this.props.dispatch(changeInExeWaitngAction(true)); // GUI表示
        return false; // 待機状態
      }
    } catch (err) {
      console.log(err);
      alert("サーバーエラー");
      return false; // エラー時も止める
    }
  }
  render() {
    const commonProps = {
      ...this.props,
      closeSw: this.closeSw,
      changeIdoPram: this.changeIdoPram,
      checkTarget: this.checkTarget,
      doExe: this.doExe,
      linkGM: this.linkGM,
      checkModelKind: this.checkModelKind,
      checkIdoPram: this.checkIdoPram,
      changeVisible: this.changeVisible,
      deleteSelectedWaterShed: this.deleteSelectedWaterShed,
      changeField: this.changeField,
      getTargetBor: this.getTargetBor,
      // 必要なら他の共通関数も追加
    };
    return (
      <div>
        <Sw title="解析実行" focusName="gmwel">
          {this.props.userLicense === 2 && <FreeUser {...commonProps} />}
          {this.props.userLicense === 3 && <PaidUser {...commonProps} windowCP={window.getCP()} />}
          {this.props.userLicense === 4 && <StanUser {...commonProps} windowCP={window.getCP()} />}
          {this.props.userLicense === 0 && <DevUser {...commonProps} windowCP={window.getCP()} />}
        </Sw>
        {this.props.regionModelWindowVisible ? <RegionModelWindow /> : null}
        {this.props.testDataWindowVisible ? <TestData /> : null}
        {this.props.outTimeWindowVisible ? <OutTime /> : null}
      </div>
    );
  }
}

/*
 * エクスポートテスト用
 * @since ando 2023-09-08
 */
export function exportTest(str) {
  console.log(this.props.analyPump + str);
}

export default connect(mapStateToProps)(Main);
